import * as React from 'react';

import { auth } from '../../firebase'; 
import config from '../../config';
// import { databaseTestingEndpoint, enableLeafLogixEndpoint } from '../../constants/api-endpoints';
import { databaseTestingEndpoint } from '../../constants/api-endpoints';
import { queueForSessionReady } from '../providers/provider-utils'; 
import { navigateTop } from '../routing/router-utils';
import BodyWrapper, { LayoutTypes } from '../layout/BodyWrapper';
import PrimaryHeader from '../styleguide/PrimaryHeader';
import BasicButton from '../styleguide/BasicButton';
import DisplayModal from '../common/DisplayModal';
import Spinner from '../common/Spinner';

import styles from './TestLinks.module.css';

const TestLinks = () => {

  // Modal onComplete message
  const [updateMsg, setUpdateMsg] = React.useState();
  
  const [dbClearResponse, setDbClearResponse] = React.useState();
  const [dbClearInProgress, setDbClearInProgress] = React.useState();
  const [dbResetResponse, setDbResetResponse] = React.useState();
  
  const [dispEmail, setDispEmail] = React.useState();
  const [dispPassword, setDispPassword] = React.useState();
  
  const [dbResetInProgress, setDbResetInProgress] = React.useState();

  const updateDB = (onSuccess, onError, isReset) => {
    if (auth.currentUser) {
      auth.currentUser.getIdToken(/* no need to force refresh */ false).then(function(idToken) {
        fetch(databaseTestingEndpoint, {
          method: isReset ? 'DELETE' : 'POST',
          headers: {
            'Authorization': idToken,
            'Content-Type': 'application/json'
          }
          // body: JSON.stringify({ dispensary_inventory_source: "leaf_logix"})
        }).then(response => {
          if (response.status === 200) {
            if (isReset) {
              onSuccess(response);
            } else {
              response.json().then(body => {
                // We'll need to display all the data
                onSuccess(body);
              });  
            }
          } else {
            response.json().then(body => {
              onError(`Error: ${body.error}`);
            });
        }}).catch(error => {
          onError(`Error: ${error.message}`);
        });
      });
    }
  };

  const resetDB = () => {
    setDbClearInProgress(true);
    setDbClearResponse('');
    const onSuccess = (response) => {
      setDbClearInProgress(false);
      setUpdateMsg('Success! database reset.');
      setDbClearResponse('Success! database reset.');
    };
    const onError = (response) => {
      setDbClearInProgress(false);
      setUpdateMsg(response);
      setDbClearResponse(response);
    };

    if (auth.currentUser) {
      updateDB(onSuccess, onError, true);
    } else {
      queueForSessionReady(() => updateDB(onSuccess, onError, true));
    }
  };

  const seedDB = () => {
    setDbResetInProgress(true);
    setDbResetResponse('');
    const onSuccess = (response) => {
      setDbResetInProgress(false);
      setUpdateMsg('Success! database seeded.');
      if (response.dispensary?.email) {
        setDispEmail(response.dispensary?.email);
      }
      if (response.dispensary?.password) {
        setDispPassword(response.dispensary?.password);
      }
      setDbResetResponse(JSON.stringify(response));
    };
    const onError = (response) => {
      setDbResetInProgress(false);
      setUpdateMsg(response);
      setDbResetResponse(response);
    };
    if (auth.currentUser) {
      updateDB(onSuccess, onError);
    } else {
      queueForSessionReady(() =>  updateDB(onSuccess, onError));
    }
  };
  
  /** sandbox LL key: 3df944beb7e84313a9e550425bc3e19b
  const enableLeafLogix = (dispId) => {
    dispId = dispId || '92a99a7f-0179-4faf-9056-ab9f5d64ead7';
    
    if (auth.currentUser) {
      const leafLogixEndpoint = enableLeafLogixEndpoint.replace('[dispId]', dispId);
      auth.currentUser.getIdToken(false).then(function(idToken) {
        fetch(leafLogixEndpoint, {
          method: 'GET',
          headers: {
            'Authorization': idToken,
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (response.status === 200) {
            alert(`Leaf Logix set as primary source for ${dispId}`);
          } else {
            response.json().then(body => {
              alert(`Error: ${body.error}`);
            });
        }}).catch(error => {
          alert(`Error: ${error.message}`);
        });
      });
    }
  };
  */
 
  // QA-ONLY! Redirect to home on production
  if (config.REACT_APP_API_DOMAIN.indexOf('ziprun-qa') === -1) {
    navigateTop('/');
  }
  
  return (
    <BodyWrapper pageLayout={LayoutTypes.Narrow}>
      <div className={styles.testWrapper}>
        <PrimaryHeader isCentered text="Testing Options" />
        <section>
          <div className={styles.info}>
            Clear the test database  
          </div>
          <div className={styles.btnWrap}>
            <BasicButton text="Reset Database" handleClick={resetDB} />
          </div>
          <div className={styles.response}>
            { dbClearInProgress 
              ? <Spinner isCentered inSmallLayout />
              : dbClearResponse 
                ? <div>{dbClearResponse}</div>
                : null
            } 
          </div>
        </section>
        <section>  
          <div className={styles.info}>
            Create test dispensary, etc.  
          </div>
          <div className={styles.btnWrap}>
            <BasicButton text="Seed Database" handleClick={seedDB} />
          </div>
          <div className={styles.response}>
            { dbResetInProgress 
              ? <Spinner isCentered inSmallLayout />
              : dbResetResponse 
                ? <div>
                    { dispEmail &&
                      <div style={{margin:'2rem', textAlign:'center'}}> 
                        <div>Email: {dispEmail}</div>
                        <div>Password: {dispPassword}</div>
                      </div>
                    }  
                    {dbResetResponse}
                  </div>
                : null
            } 
          </div>
        </section>
        {/*
        <section>
          <div className={styles.info}>
            Set inventory source to Leaf Logix  
          </div>
          <div className={styles.btnWrap}>
            <BasicButton text="Enable Leaf Logix" handleClick={enableLeafLogix} />
        </div>
        </section>
        */} 
      </div>
      { updateMsg &&
        <DisplayModal closeFn={() => setUpdateMsg('') }>
          <div>{updateMsg}</div>
        </DisplayModal>
      }
    </BodyWrapper>
  )
}

export default TestLinks;